export default "__VITE_ASSET__CbZTZVmc__"